export const environment = {
  production: true,
  API_URL: "https://coffre-fort.decisiel-expertise.fr/",
  API_SERVICE_URL: "//api-coffre-fort.decisiel-expertise.fr/api/v1.0/", 
  API_SIMULATEUR_URL: "https://decisielsimulator-api-prod.azurewebsites.net/api/",
  RECAPTCHA_SITE_KEY: "6LdYSIMhAAAAAOa6lQz3Ls2O_hBoDwGmR1riyJT0", 
  API_SIMULATEUR_KEY: "RklQQVJDT19CQ09fU0lNVUxBVEVfUE9SVEFHRQ==",
  UrlDecisielApi: "https://decisiel-webapi-prod.azurewebsites.net/api/v1.0/"
};
